export default __webpack_public_path__ + "static/media/p7_game12.85f146e4.png";